<template>
  <div class="Examine">
    <div>
      <el-select v-if="$store.state.Login.Jurisdiction == 0" size="medium" v-model="Factory" style="width: 110px; padding: 0px 0px 0px 10px;" clearable :placeholder="$t('system.选择厂区')">
        <el-option
          v-for="item in $PublicJs.factory"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      <el-select size="medium" v-if="$store.state.Login.Jurisdiction == 0 || $store.state.Login.Department == 'Test'" v-model="Department" style="width: 150px; padding: 0px 0px 0px 10px;" clearable :placeholder="$t('system.选择部门')">
        <el-option
          v-for="item in $PublicJs.department"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      <el-input size="medium" clearable v-model="Text" style="width: 250px; padding: 0px 10px 0px 10px;" @keyup.enter.native="Butsele()" :placeholder="$t('All.品名') + '/' + $t('All.工单号')+ '/' + $t('All.系统单号') + '/' + $t('All.实验名称')"></el-input>
      <el-button type="primary" icon="el-icon-search" size="small" @click="Butsele()">{{$t('All.搜索')}}</el-button>
    </div>
    <div style="height: calc(100% - 75px);">
      <!-- <template> -->
        <el-table :data="tableData" style="width: 100%" height="100%">
          <el-table-column align="center" type="index" width="60">
          </el-table-column>
          <el-table-column align="center" sortable prop="Date" :label="this.$t('system.创建日期')" width="160">
          </el-table-column>
          <el-table-column align="center" prop="Numbers" :label="$t('All.通知单号')" width="145">
          </el-table-column>
          <el-table-column align="center" prop="Gongdan" :label="$t('All.工单号')" width="100">
          </el-table-column>
          <el-table-column align="center" prop="Product_item" :label="$t('All.品名') + '/' + $t('All.料号')" width="140">
          </el-table-column>
          <el-table-column align="center" prop="Urgent_state" sortable :label="$t('All.紧急状态')" width="120">
            <template slot-scope="scope">
              <el-tag
              effect="dark"
              :type="scope.row.Urgent_state === $t('All.特急') ? 'danger' : scope.row.Urgent_state === $t('All.急') ?'warning': ''"
              disable-transitions>{{ $t(`All.${scope.row.Urgent_state}`) }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="Receivername" sortable :label="$t('All.接单人')" >
          </el-table-column>
          <el-table-column align="center" prop="Department" sortable :label="$t('All.部门')">
          </el-table-column>
          <el-table-column align="center" prop="Applicantname" sortable :label="$t('All.申请人')" width="100">
          </el-table-column>
          <el-table-column align="center" prop="Statename" sortable :label="this.$t('system.状态')">
            <template slot-scope="scope">
              {{ $PublicJs.Resultyilds(scope.row.State) }}
            </template>
          </el-table-column>
          <el-table-column align="center"  :label="this.$t('system.操作')" width="160" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" @click="Testflow(scope.row)">View</el-button>
              <el-button v-if="((scope.row.State !== 5 || scope.row.State !== 10) && $store.state.Login.User == scope.row.Applicant) || $store.state.Login.Jurisdiction == 0" size="mini" type="danger" @click="Dellaboratryhd(scope.row)">Del</el-button>
            </template>
          </el-table-column>
        </el-table>
      <!-- </template> -->
    </div>
    <el-pagination
      style="text-align: center; padding: 5px;"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageindex"
      :page-sizes="[10, 30, 40, 100, 200, 300, 400]"
      :page-size="page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
  data () {
    return {
      tableData: [],
      total: 0,
      page_size: 10,
      pageindex: 1,
      Text: '',
      Factory: '',
      Department: ''
    }
  },
  created () {
    this.Lagetflowhd()
  },
  props: ['Addtab', 'RemoveTab', 'Renewtargename'],
  mounted () {
  },
  methods: {
    ...mapMutations(['Testdata', 'TabComponentFun']),
    async Lagetflowhd () {
      const intfs = {
        Pageindex: this.pageindex,
        PageSize: this.page_size,
        UserData: this.$store.state.Login,
        Text: this.Text,
        Factory: this.Factory,
        Department: this.Department
      }
      const { data: res } = await this.$http.post('/api/Laboratory/Lagetflowhd', intfs)
      if (res.status !== 200) return this.$message.error(res.msg)
      this.total = res.response.TotalCount
      this.tableData = res.response.Laboratorydatahd
    },
    async Butsele () {
      this.pageindex = 1
      this.page_size = 10
      this.Lagetflowhd()
    },
    async Dellaboratryhd (row) {
      const { data: res } = await this.$http.get('/api/Laboratory/Dellaboratryhd?Numbers=' + row.Numbers)
      if (res.status !== 200) return this.$message.error(res.msg)
      this.Lagetflowhd()
    },
    Setquer () {
      this.pageindex = 1
      this.Lagetflowhd()
    },
    Testflow (row) {
      this.Testdata(row)
      this.Addtab(row.Numbers, 'Testsheethdxq', [])
    },
    handleSizeChange (val) {
      this.page_size = val
      this.Lagetflowhd()
    },
    handleCurrentChange (val) {
      this.pageindex = val
      this.Lagetflowhd()
    }
  }
}
</script>
<style lang="less" scoped>
/** talbe表头置顶**/
/deep/ .el-table {
    overflow: visible;
 }

 /deep/ .el-table__header-wrapper {
    position: sticky;
    top: 0px;
    z-index: 10;
 }
 .Examine {
  height: 100%;
 }
</style>
